function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import * as e from "react";

function n() {
  return n = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, n.apply(this, arguments);
}

var r,
    t,
    i = ["children", "options"];
!function (e) {
  e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}(r || (r = {})), function (e) {
  e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}(t || (t = {}));
var a = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce(function (e, n) {
  return e[n.toLowerCase()] = n, e;
}, {
  for: "htmlFor"
}),
    o = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: "“"
},
    c = ["style", "script"],
    l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,
    u = /mailto:/i,
    s = /\n{2,}$/,
    f = /^(\s*>[\s\S]*?)(?=\n{2,})/,
    d = /^ *> ?/gm,
    p = /^ {2,}\n/,
    h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/,
    m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/,
    g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,
    y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
    v = /^(?:\n *)*\n/,
    k = /\r\n?/g,
    x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/,
    b = /^\[\^([^\]]+)]/,
    E = /\f/g,
    w = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/,
    S = /^\s*?\[(x|\s)\]/,
    C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
    A = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
    O = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,
    $ = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i,
    T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,
    L = /^<!--[\s\S]*?(?:-->)/,
    R = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/,
    z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,
    M = /^\{.*\}$/,
    I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
    U = /^<([^ >]+@[^ >]+)>/,
    j = /^<([^ >]+:\/[^ >]+)>/,
    B = /-([a-z])?/gi,
    N = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/,
    H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,
    D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/,
    P = /^\[([^\]]*)\] ?\[([^\]]*)\]/,
    _ = /(\[|\])/g,
    F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,
    W = /\t/g,
    G = /(^ *\||\| *$)/g,
    Z = /^ *:-+: *$/,
    q = /^ *:-+ *$/,
    V = /^ *-+: *$/,
    X = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)",
    Q = new RegExp("^([*_])\\1" + X + "\\1\\1(?!\\1)"),
    J = new RegExp("^([*_])" + X + "\\1(?!\\1|\\w)"),
    K = new RegExp("^==" + X + "=="),
    Y = new RegExp("^~~" + X + "~~"),
    ee = /^\\([^0-9A-Za-z\s])/,
    ne = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,
    re = /^\n+/,
    te = /^([ \t]*)/,
    ie = /\\([^\\])/g,
    ae = / *\n+$/,
    oe = /(?:^|\n)( *)$/,
    ce = "(?:\\d+\\.)",
    le = "(?:[*+-])";

function ue(e) {
  return "( *)(" + (1 === e ? ce : le) + ") +";
}

var se = ue(1),
    fe = ue(2);

function de(e) {
  return new RegExp("^" + (1 === e ? se : fe));
}

var pe = de(1),
    he = de(2);

function me(e) {
  return new RegExp("^" + (1 === e ? se : fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? ce : le) + " )[^\\n]*)*(\\n|$)", "gm");
}

var ge = me(1),
    ye = me(2);

function ve(e) {
  var n = 1 === e ? ce : le;
  return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}

var ke = ve(1),
    xe = ve(2);

function be(e, n) {
  var r = 1 === n,
      t = r ? ke : xe,
      i = r ? ge : ye,
      a = r ? pe : he;
  return {
    match: function match(e, n, r) {
      var i = oe.exec(r);
      return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
    },
    order: 1,
    parse: function parse(e, n, t) {
      var o = r ? +e[2] : void 0,
          c = e[0].replace(s, "\n").match(i),
          l = !1;
      return {
        items: c.map(function (e, r) {
          var i = a.exec(e)[0].length,
              o = new RegExp("^ {1," + i + "}", "gm"),
              u = e.replace(o, "").replace(a, ""),
              s = r === c.length - 1,
              f = -1 !== u.indexOf("\n\n") || s && l;
          l = f;
          var d,
              p = t.inline,
              h = t.list;
          t.list = !0, f ? (t.inline = !1, d = u.replace(ae, "\n\n")) : (t.inline = !0, d = u.replace(ae, ""));
          var m = n(d, t);
          return t.inline = p, t.list = h, m;
        }),
        ordered: r,
        start: o
      };
    },
    render: function render(n, r, t) {
      return e(n.ordered ? "ol" : "ul", {
        key: t.key,
        start: "20" === n.type ? n.start : void 0
      }, n.items.map(function (n, i) {
        return e("li", {
          key: i
        }, r(n, t));
      }));
    }
  };
}

var Ee = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),
    we = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,
    Se = [f, m, g, C, O, A, L, N, ge, ke, ye, xe],
    Ce = [].concat(Se, [/^[^\n]+(?:  \n|\n{2,})/, $, z]);

function Ae(e) {
  return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}

function Oe(e) {
  return V.test(e) ? "right" : Z.test(e) ? "center" : q.test(e) ? "left" : null;
}

function $e(e, n, r, t) {
  var i = r.inTable;
  r.inTable = !0;
  var a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce(function (e, i) {
    return "|" === i.trim() ? e.push(t ? {
      type: "26"
    } : {
      type: "27",
      text: i
    }) : "" !== i && e.push.apply(e, n(i, r)), e;
  }, []);
  r.inTable = i;
  var o = [[]];
  return a.forEach(function (e, n) {
    "26" === e.type ? 0 !== n && n !== a.length - 1 && o.push([]) : ("27" !== e.type || null != a[n + 1] && "26" !== a[n + 1].type || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
  }), o;
}

function Te(e, n, r) {
  r.inline = !0;
  var t = e[2] ? e[2].replace(G, "").split("|").map(Oe) : [],
      i = e[3] ? function (e, n, r) {
    return e.trim().split("\n").map(function (e) {
      return $e(e, n, r, !0);
    });
  }(e[3], n, r) : [],
      a = $e(e[1], n, r, !!i.length);
  return r.inline = !1, i.length ? {
    align: t,
    cells: i,
    header: a,
    type: "25"
  } : {
    children: a,
    type: "21"
  };
}

function Le(e, n) {
  return null == e.align[n] ? {} : {
    textAlign: e.align[n]
  };
}

function Re(e) {
  return function (n, r) {
    return r.inline ? e.exec(n) : null;
  };
}

function ze(e) {
  return function (n, r) {
    return r.inline || r.simple ? e.exec(n) : null;
  };
}

function Me(e) {
  return function (n, r) {
    return r.inline || r.simple ? null : e.exec(n);
  };
}

function Ie(e) {
  return function (n) {
    return e.exec(n);
  };
}

function Ue(e, n, r) {
  if (n.inline || n.simple) return null;
  if (r && !r.endsWith("\n")) return null;
  var t = "";
  e.split("\n").every(function (e) {
    return !Se.some(function (n) {
      return n.test(e);
    }) && (t += e + "\n", e.trim());
  });
  var i = t.trimEnd();
  return "" == i ? null : [t, i];
}

function je(e) {
  try {
    if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
  } catch (e) {
    return null;
  }

  return e;
}

function Be(e) {
  return e.replace(ie, "$1");
}

function Ne(e, n, r) {
  var t = r.inline || !1,
      i = r.simple || !1;
  r.inline = !0, r.simple = !0;
  var a = e(n, r);
  return r.inline = t, r.simple = i, a;
}

function He(e, n, r) {
  var t = r.inline || !1,
      i = r.simple || !1;
  r.inline = !1, r.simple = !0;
  var a = e(n, r);
  return r.inline = t, r.simple = i, a;
}

function De(e, n, r) {
  var t = r.inline || !1;
  r.inline = !1;
  var i = e(n, r);
  return r.inline = t, i;
}

var Pe = function Pe(e, n, r) {
  return {
    children: Ne(n, e[1], r)
  };
};

function _e() {
  return {};
}

function Fe() {
  return null;
}

function We() {
  return [].slice.call(arguments).filter(Boolean).join(" ");
}

function Ge(e, n, r) {
  for (var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);) {
    i.shift();
  }

  return t || r;
}

function Ze(e, n) {
  var r = Ge(n, e);
  return r ? "function" == typeof r || "object" == _typeof(r) && "render" in r ? r : Ge(n, e + ".component", e) : e;
}

function qe(r, t) {
  var i;
  void 0 === r && (r = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || Ae, t.namedCodesToUnicode = t.namedCodesToUnicode ? n({}, o, t.namedCodesToUnicode) : o;
  var s = t.createElement || e.createElement;

  function G(e, r) {
    var i = Ge(t.overrides, e + ".props", {});
    return s.apply(void 0, [Ze(e, t.overrides), n({}, r, i, {
      className: We(null == r ? void 0 : r.className, i.className) || void 0
    })].concat([].slice.call(arguments, 2)));
  }

  function Z(n) {
    n = n.replace(w, "");
    var r = !1;
    t.forceInline ? r = !0 : t.forceBlock || (r = !1 === F.test(n));

    for (var i = ce(oe(r ? n : n.trimEnd().replace(re, "") + "\n\n", {
      inline: r
    })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();) {
      i.pop();
    }

    if (null === t.wrapper) return i;
    var a,
        o = t.wrapper || (r ? "span" : "div");
    if (i.length > 1 || t.forceWrapper) a = i;else {
      if (1 === i.length) return "string" == typeof (a = i[0]) ? G("span", {
        key: "outer"
      }, a) : a;
      a = null;
    }
    return /*#__PURE__*/e.createElement(o, {
      key: "outer"
    }, a);
  }

  function q(n) {
    var r = n.match(l);
    return r ? r.reduce(function (n, r, t) {
      var i = r.indexOf("=");

      if (-1 !== i) {
        var o = function (e) {
          return -1 !== e.indexOf("-") && null === e.match(R) && (e = e.replace(B, function (e, n) {
            return n.toUpperCase();
          })), e;
        }(r.slice(0, i)).trim(),
            c = function (e) {
          var n = e[0];
          return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
        }(r.slice(i + 1).trim()),
            l = a[o] || o,
            u = n[l] = function (e, n) {
          return "style" === e ? n.split(/;\s?/).reduce(function (e, n) {
            var r = n.slice(0, n.indexOf(":"));
            return e[r.trim().replace(/(-[a-z])/g, function (e) {
              return e[1].toUpperCase();
            })] = n.slice(r.length + 1).trim(), e;
          }, {}) : "href" === e || "src" === e ? je(n) : (n.match(M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
        }(o, c);

        "string" == typeof u && ($.test(u) || z.test(u)) && (n[l] = /*#__PURE__*/e.cloneElement(Z(u.trim()), {
          key: t
        }));
      } else "style" !== r && (n[a[r] || r] = !0);

      return n;
    }, {}) : null;
  }

  var V = [],
      X = {},
      ie = ((i = {})[0] = {
    match: Me(f),
    order: 1,
    parse: function parse(e, n, r) {
      return {
        children: n(e[0].replace(d, ""), r)
      };
    },
    render: function render(e, n, r) {
      return G("blockquote", {
        key: r.key
      }, n(e.children, r));
    }
  }, i[1] = {
    match: Ie(p),
    order: 1,
    parse: _e,
    render: function render(e, n, r) {
      return G("br", {
        key: r.key
      });
    }
  }, i[2] = {
    match: Me(h),
    order: 1,
    parse: _e,
    render: function render(e, n, r) {
      return G("hr", {
        key: r.key
      });
    }
  }, i[3] = {
    match: Me(g),
    order: 0,
    parse: function parse(e) {
      return {
        lang: void 0,
        text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
      };
    },
    render: function render(e, r, t) {
      return G("pre", {
        key: t.key
      }, G("code", n({}, e.attrs, {
        className: e.lang ? "lang-" + e.lang : ""
      }), e.text));
    }
  }, i[4] = {
    match: Me(m),
    order: 0,
    parse: function parse(e) {
      return {
        attrs: q(e[3] || ""),
        lang: e[2] || void 0,
        text: e[4],
        type: "3"
      };
    }
  }, i[5] = {
    match: ze(y),
    order: 3,
    parse: function parse(e) {
      return {
        text: e[2]
      };
    },
    render: function render(e, n, r) {
      return G("code", {
        key: r.key
      }, e.text);
    }
  }, i[6] = {
    match: Me(x),
    order: 0,
    parse: function parse(e) {
      return V.push({
        footnote: e[2],
        identifier: e[1]
      }), {};
    },
    render: Fe
  }, i[7] = {
    match: Re(b),
    order: 1,
    parse: function parse(e) {
      return {
        target: "#" + t.slugify(e[1]),
        text: e[1]
      };
    },
    render: function render(e, n, r) {
      return G("a", {
        key: r.key,
        href: je(e.target)
      }, G("sup", {
        key: r.key
      }, e.text));
    }
  }, i[8] = {
    match: Re(S),
    order: 1,
    parse: function parse(e) {
      return {
        completed: "x" === e[1].toLowerCase()
      };
    },
    render: function render(e, n, r) {
      return G("input", {
        checked: e.completed,
        key: r.key,
        readOnly: !0,
        type: "checkbox"
      });
    }
  }, i[9] = {
    match: Me(t.enforceAtxHeadings ? A : C),
    order: 1,
    parse: function parse(e, n, r) {
      return {
        children: Ne(n, e[2], r),
        id: t.slugify(e[2]),
        level: e[1].length
      };
    },
    render: function render(e, n, r) {
      return G("h" + e.level, {
        id: e.id,
        key: r.key
      }, n(e.children, r));
    }
  }, i[10] = {
    match: Me(O),
    order: 0,
    parse: function parse(e, n, r) {
      return {
        children: Ne(n, e[1], r),
        level: "=" === e[2] ? 1 : 2,
        type: "9"
      };
    }
  }, i[11] = {
    match: Ie($),
    order: 1,
    parse: function parse(e, n, r) {
      var t,
          i = e[3].match(te),
          a = new RegExp("^" + i[1], "gm"),
          o = e[3].replace(a, ""),
          l = (t = o, Ce.some(function (e) {
        return e.test(t);
      }) ? De : Ne),
          u = e[1].toLowerCase(),
          s = -1 !== c.indexOf(u),
          f = {
        attrs: q(e[2]),
        noInnerParse: s,
        tag: (s ? u : e[1]).trim()
      };
      return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, o, r), r.inAnchor = !1, f;
    },
    render: function render(e, r, t) {
      return G(e.tag, n({
        key: t.key
      }, e.attrs), e.text || r(e.children, t));
    }
  }, i[13] = {
    match: Ie(z),
    order: 1,
    parse: function parse(e) {
      return {
        attrs: q(e[2] || ""),
        tag: e[1].trim()
      };
    },
    render: function render(e, r, t) {
      return G(e.tag, n({}, e.attrs, {
        key: t.key
      }));
    }
  }, i[12] = {
    match: Ie(L),
    order: 1,
    parse: function parse() {
      return {};
    },
    render: Fe
  }, i[14] = {
    match: ze(we),
    order: 1,
    parse: function parse(e) {
      return {
        alt: e[1],
        target: Be(e[2]),
        title: e[3]
      };
    },
    render: function render(e, n, r) {
      return G("img", {
        key: r.key,
        alt: e.alt || void 0,
        title: e.title || void 0,
        src: je(e.target)
      });
    }
  }, i[15] = {
    match: Re(Ee),
    order: 3,
    parse: function parse(e, n, r) {
      return {
        children: He(n, e[1], r),
        target: Be(e[2]),
        title: e[3]
      };
    },
    render: function render(e, n, r) {
      return G("a", {
        key: r.key,
        href: je(e.target),
        title: e.title
      }, n(e.children, r));
    }
  }, i[16] = {
    match: Re(j),
    order: 0,
    parse: function parse(e) {
      return {
        children: [{
          text: e[1],
          type: "27"
        }],
        target: e[1],
        type: "15"
      };
    }
  }, i[17] = {
    match: function match(e, n) {
      return n.inAnchor ? null : Re(I)(e, n);
    },
    order: 0,
    parse: function parse(e) {
      return {
        children: [{
          text: e[1],
          type: "27"
        }],
        target: e[1],
        title: void 0,
        type: "15"
      };
    }
  }, i[18] = {
    match: Re(U),
    order: 0,
    parse: function parse(e) {
      var n = e[1],
          r = e[1];
      return u.test(r) || (r = "mailto:" + r), {
        children: [{
          text: n.replace("mailto:", ""),
          type: "27"
        }],
        target: r,
        type: "15"
      };
    }
  }, i[20] = be(G, 1), i[33] = be(G, 2), i[19] = {
    match: Me(v),
    order: 3,
    parse: _e,
    render: function render() {
      return "\n";
    }
  }, i[21] = {
    match: Ue,
    order: 3,
    parse: Pe,
    render: function render(e, n, r) {
      return G("p", {
        key: r.key
      }, n(e.children, r));
    }
  }, i[22] = {
    match: Re(H),
    order: 0,
    parse: function parse(e) {
      return X[e[1]] = {
        target: e[2],
        title: e[4]
      }, {};
    },
    render: Fe
  }, i[23] = {
    match: ze(D),
    order: 0,
    parse: function parse(e) {
      return {
        alt: e[1] || void 0,
        ref: e[2]
      };
    },
    render: function render(e, n, r) {
      return X[e.ref] ? G("img", {
        key: r.key,
        alt: e.alt,
        src: je(X[e.ref].target),
        title: X[e.ref].title
      }) : null;
    }
  }, i[24] = {
    match: Re(P),
    order: 0,
    parse: function parse(e, n, r) {
      return {
        children: n(e[1], r),
        fallbackChildren: n(e[0].replace(_, "\\$1"), r),
        ref: e[2]
      };
    },
    render: function render(e, n, r) {
      return X[e.ref] ? G("a", {
        key: r.key,
        href: je(X[e.ref].target),
        title: X[e.ref].title
      }, n(e.children, r)) : G("span", {
        key: r.key
      }, n(e.fallbackChildren, r));
    }
  }, i[25] = {
    match: Me(N),
    order: 1,
    parse: Te,
    render: function render(e, n, r) {
      var t = e;
      return G("table", {
        key: r.key
      }, G("thead", null, G("tr", null, t.header.map(function (e, i) {
        return G("th", {
          key: i,
          style: Le(t, i)
        }, n(e, r));
      }))), G("tbody", null, t.cells.map(function (e, i) {
        return G("tr", {
          key: i
        }, e.map(function (e, i) {
          return G("td", {
            key: i,
            style: Le(t, i)
          }, n(e, r));
        }));
      })));
    }
  }, i[27] = {
    match: Ie(ne),
    order: 4,
    parse: function parse(e) {
      return {
        text: e[0].replace(T, function (e, n) {
          return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
        })
      };
    },
    render: function render(e) {
      return e.text;
    }
  }, i[28] = {
    match: ze(Q),
    order: 2,
    parse: function parse(e, n, r) {
      return {
        children: n(e[2], r)
      };
    },
    render: function render(e, n, r) {
      return G("strong", {
        key: r.key
      }, n(e.children, r));
    }
  }, i[29] = {
    match: ze(J),
    order: 3,
    parse: function parse(e, n, r) {
      return {
        children: n(e[2], r)
      };
    },
    render: function render(e, n, r) {
      return G("em", {
        key: r.key
      }, n(e.children, r));
    }
  }, i[30] = {
    match: ze(ee),
    order: 1,
    parse: function parse(e) {
      return {
        text: e[1],
        type: "27"
      };
    }
  }, i[31] = {
    match: ze(K),
    order: 3,
    parse: Pe,
    render: function render(e, n, r) {
      return G("mark", {
        key: r.key
      }, n(e.children, r));
    }
  }, i[32] = {
    match: ze(Y),
    order: 3,
    parse: Pe,
    render: function render(e, n, r) {
      return G("del", {
        key: r.key
      }, n(e.children, r));
    }
  }, i);
  !0 === t.disableParsingRawHTML && (delete ie[11], delete ie[13]);

  var ae,
      oe = function (e) {
    var n = Object.keys(e);

    function r(t, i) {
      for (var a = [], o = ""; t;) {
        for (var c = 0; c < n.length;) {
          var l = n[c],
              u = e[l],
              s = u.match(t, i, o);

          if (s) {
            var f = s[0];
            t = t.substring(f.length);
            var d = u.parse(s, r, i);
            null == d.type && (d.type = l), a.push(d), o = f;
            break;
          }

          c++;
        }
      }

      return a;
    }

    return n.sort(function (n, r) {
      var t = e[n].order,
          i = e[r].order;
      return t !== i ? t - i : n < r ? -1 : 1;
    }), function (e, n) {
      return r(function (e) {
        return e.replace(k, "\n").replace(E, "").replace(W, "    ");
      }(e), n);
    };
  }(ie),
      ce = (ae = function (e, n) {
    return function (r, t, i) {
      var a = e[r.type].render;
      return n ? n(function () {
        return a(r, t, i);
      }, r, t, i) : a(r, t, i);
    };
  }(ie, t.renderRule), function e(n, r) {
    if (void 0 === r && (r = {}), Array.isArray(n)) {
      for (var t = r.key, i = [], a = !1, o = 0; o < n.length; o++) {
        r.key = o;
        var c = e(n[o], r),
            l = "string" == typeof c;
        l && a ? i[i.length - 1] += c : null !== c && i.push(c), a = l;
      }

      return r.key = t, i;
    }

    return ae(n, e, r);
  }),
      le = Z(r);

  return V.length ? G("div", null, le, G("footer", {
    key: "footer"
  }, V.map(function (e) {
    return G("div", {
      id: t.slugify(e.identifier),
      key: e.identifier
    }, e.identifier, ce(oe(e.footnote, {
      inline: !0
    })));
  }))) : le;
}

export default function (n) {
  var r = n.children,
      t = void 0 === r ? "" : r,
      a = n.options,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        i = {},
        a = Object.keys(e);

    for (t = 0; t < a.length; t++) {
      n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
    }

    return i;
  }(n, i);

  return /*#__PURE__*/e.cloneElement(qe(t, a), o);
}
export { r as RuleType, qe as compiler, Ae as slugify };